/**
 * The angularjs states related to the module AddAccountModule
 */
addAccountStates.$inject = ['$urlRouterProvider', '$stateProvider'];
export function addAccountStates($urlRouterProvider, $stateProvider) {
  // Redirection to keep previous state with white background.
  $urlRouterProvider.when('/{companyId}/parameters/add-account?{errorId}', [
    '$match',
    function ($match) {
      let path = `/${$match.companyId}/fuse/parameters/add-account`;
      if ($match.errorId) {
        path += `?errorId=${$match.errorId}`;
      }
      return path;
    },
  ]);

  $stateProvider
    .state('auth.alcmeon.fuse.parameters.add-account', {
      url: '/add-account?errorId',
      views: {
        'container@auth': {
          template: '<angular-add-account></angular-add-account>',
        },
      },
    })

    .state('auth.alcmeon.fuse.parameters.account.whatsapp-verify', {
      url: '/whatsapp-verify',
      views: {
        'container@auth': {
          template: require('src/ajs-app/components/parameters/addAccountWhatsapp/verify.html'),
          controller: 'WhatsappVerifyController',
        },
      },
    })
    .state('auth.alcmeon.fuse.parameters.account.whatsapp-pre-verify', {
      url: '/whatsapp-pre-verify',
      views: {
        'container@auth': {
          template: require('src/ajs-app/components/parameters/addAccountWhatsapp/pre-verify.html'),
          controller: 'WhatsappPreVerifyController',
        },
      },
    })
    .state('auth.alcmeon.fuse.parameters.line-register', {
      url: '/line-register?authId',
      views: {
        'container@auth': {
          template: require('src/ajs-app/components/parameters/addAccountLine/addAccountLine.html'),
          controller: 'LineRegisterController',
        },
      },
    })
    .state('auth.alcmeon.fuse.parameters.line-register-mulesoft', {
      url: '/line-register-mulesoft?authId',
      views: {
        'container@auth': {
          template: require('src/ajs-app/components/parameters/addAccountLineMulesoft/addAccountLineMulesoft.html'),
          controller: 'LineMulesoftRegisterController',
        },
      },
    })
    .state('auth.alcmeon.fuse.parameters.kakaotalk-register', {
      url: '/kakaotalk-register?authId',
      views: {
        'container@auth': {
          template: require('src/ajs-app/components/parameters/addAccountKakaotalk/addAccountKakaotalk.html'),
          controller: 'KakaotalkRegisterController',
        },
      },
    })
    .state('auth.alcmeon.parameters.add-account-tiktok', {
      url: '/add-account-tiktok?authId&siteId&code',
      views: {
        'container@auth': {
          controller: [
            '$scope',
            '$stateParams',
            function ($scope, $stateParams) {
              $scope.code = $stateParams.code;
              $scope.authId = $stateParams.authId;
              $scope.siteId = $stateParams.siteId;
              $scope.siteType = 'tiktok'; // TODO use SiteType enum when migrating in angular
            },
          ],
          template:
            '<angular-finalize-add-account [site-type]="siteType" [auth-id]="authId" [site-id]="siteId" [code]="code"></angular-finalize-add-account>',
        },
      },
    })
    .state('auth.alcmeon.fuse.parameters.add-account-facebook-locations', {
      url: '/add-account-facebook-locations',
      views: {
        'container@auth': {
          template: '<angular-facebook-locations></angular-facebook-locations>',
        },
      },
    })

    /*
     * TODO These states should have common state .whatsapp-*.*
     *  - auth.alcmeon.fuse.parameters.whatsapp-connect
     *  - auth.alcmeon.fuse.parameters.whatsapp-vonage-register
     *  - auth.alcmeon.fuse.parameters.whatsapp-vonage-reauthorize
     *  - auth.alcmeon.fuse.parameters.whatsapp-360d-register
     */
    .state('auth.alcmeon.fuse.parameters.whatsapp-connect', {
      url: '/whatsapp-connect?authId',
      views: {
        'container@auth': {
          template: require('src/ajs-app/components/parameters/addAccountWhatsapp/connect.html'),
          controller: 'WhatsappConnectController',
        },
      },
    })
    .state('auth.alcmeon.fuse.parameters.whatsapp-vonage-register', {
      url: '/whatsapp-vonage-register',
      views: {
        'container@auth': {
          template: `<angular-whatsapp-account-vonage></angular-whatsapp-account-vonage>`,
        },
      },
    })
    .state('auth.alcmeon.fuse.parameters.whatsapp-vonage-reauthorize', {
      url: '/whatsapp-vonage-reauthorize?authId',
      views: {
        'container@auth': {
          template: `<angular-whatsapp-account-vonage></angular-whatsapp-account-vonage>`,
        },
      },
    })
    .state('auth.alcmeon.fuse.parameters.whatsapp-360d-register', {
      url: '/whatsapp-360d-register?authId',
      views: {
        'container@auth': {
          template: require('src/ajs-app/components/parameters/addAccountWhatsappVia360D/addAccountWhatsappVia360D.html'),
          controller: 'WhatsappVia360DRegisterController',
        },
      },
    });
}
